import { Milestone } from './FormMilestones'
import { parseLabel } from 'app/views/forms/parseLabel'

export const FormMilestonesPrint = ({ value, title, typeProps = {} }) => {
  const { phases = [] } = typeProps
  const parsedTitle = parseLabel(title)

  return (
    <>
      <div className='form-read-only-header'>{parsedTitle}</div>
      {phases.map((phase, index) => {
        const milestone = value?.[index]
        if (!milestone) { return null }
        return <Milestone key={index} index={index} phase={phase} milestone={milestone} />
      })}
    </>
  )
}
